<template>
  <div id="tabNav">
    <div :class="{ 'tabItem':true, 'active': activeIndex==1 }" @click="nextGo(1)">
      <div :class="{ 'icon':true, 'activeDo': activeIndex==1 }"><i class="fa fa-search" aria-hidden="true"></i></div>
      <div class="iconText">发票查询</div>
    </div>
    <div :class="{ 'tabItem':true, 'active': activeIndex==2 }" @click="nextGo(2)">
      <div :class="{ 'icon':true, 'activeDo': activeIndex==2 }"><i class="fa fa-plus" aria-hidden="true"></i></div>
      <div class="iconText">发票开具</div>
    </div>
    <div :class="{ 'tabItem':true, 'active': activeIndex==3 }" @click="nextGo(3)">
      <div :class="{ 'icon':true, 'activeDo': activeIndex==3 }"><i class="fa fa-question" aria-hidden="true"></i></div>
      <div class="iconText">发票帮助</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tab',
  mounted () {
    this.pathIndex()
  },
  data () {
    return {
      activeIndex: 2
    }
  },
  watch: {
    '$route' (to, from) {
      let path = to.path
      switch (path) {
        case '/invoiceSearch' : this.activeIndex = 1; break
        case '/' : this.activeIndex = 2; break
        case '/invoiceHelp' : this.activeIndex = 3; break
      }
    }
  },
  methods: {
    nextGo (index) {
      this.activeIndex = index
      switch (index) {
        case 1 : this.$router.push('/invoiceSearch'); break
        case 2 : this.$router.push('/'); break
        case 3 : this.$router.push('/invoiceHelp'); break
      }
    },
    pathIndex () {
      let path = this.$route.path
      switch (path) {
        case '/invoiceSearch' : this.activeIndex = 1; break
        case '/' : this.activeIndex = 2; break
        case '/invoiceHelp' : this.activeIndex = 3; break
      }
    }
  }
}
</script>

<style scoped>
  .icon{
    height: 60%;
    line-height: 30px;
    text-align: center;
    font-size: 22px;
  }
  .active{
    color: #1296db;
  }
  .tabItem{
    flex: 1;
    height: 100%;
  }
  #tabNav{
    width: 100%;
    height: 50px;
    background-color: white;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    box-shadow: 0px -3px 10px 0px rgba(0, 0, 0, 0.2);
  }
  .iconText{
    height: 35%;
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    transition: all 0.5s;
  }
  .activeDo{
    animation: bounceTo 0.5s;
  }
  @keyframes bounceTo {
    from, 20%, 40%, 60%, 80%, to {
      animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
    }
    0% {
      font-size: 22px;
    }
    50% {
      font-size: 30px;
    }
    to {
      font-size: 22px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tab.vue